import type { ThirdPartyPlugin } from '../types';
import { promisifyLoad } from '../utils';
import { setup, load } from './script';
import type { Lintrk } from './types';

declare global {
  interface Window {
    /**
     * Linkedin pixel
     * @see [linkedin-docs](https://www.linkedin.com/help/lms/answer/a427660?accountId=509436254)
     */
    lintrk: Lintrk;
  }
}

// Note: you will find these ids of the events in imeplentation of this pixel

const linkedinPixel: ThirdPartyPlugin = () => {
  setup();

  return {
    entry: window.lintrk,
    load: promisifyLoad(load),
  };
};

export default linkedinPixel;
